import { QUESTIONS } from "./questions.js";

const RESULTS_FUNCTION = "/.netlify/functions/submitQuizResults";

export async function submitQuiz({ email, uid, score, topTwo, source, groupScores, perQuestion }) {
  const questionsAndAnswers = perQuestion.map((pq) => {
    const q = QUESTIONS[pq.idx];
    return {
      questionIndex: pq.idx,
      questionText: q.text,
      answer: pq.answer,
      group: q.group,
    };
  });

  const areaScores = groupScores.map((g) => {
    let colour = "empty";
    if (g.norm !== null) {
      if (g.norm >= 0.75) colour = "green";
      else if (g.norm >= 0.4) colour = "orange";
      else colour = "red";
    }
    return { area: g.label, score: g.score, colour };
  });

  const payload = {
    email: email || "",
    uid: uid || "",
    finalScore: score,
    topTwo: topTwo.map((t) => t.shortLabel).join(", "),
    source: source || "organic",
    questionsAndAnswers,
    areaScores,
  };

  const resp = await fetch(RESULTS_FUNCTION, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`Submit failed (${resp.status}): ${text}`);
  }

  return resp.json();
}
